import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import darkLogo from "../../assets/darkLogo.png";
import lightLogo from "../../assets/logo.png";
import errorgif from "../../assets/errors/gif404.gif";
import { Button } from "primereact/button";
import { getToken, getUserRole } from "../../utils/auth";
import { useAppContext } from "../../context/AppContext";

const Error404 = () => {
  const token = getToken();
  const role = getUserRole();
  const dark = localStorage.getItem('appDarkMode')
  const context = useAppContext();

  const navigate = useNavigate();

  const redirectToDashboardOrLogin = async () => {
    try {
      if(role === 'ibSystem'){
        navigate("/admin");
      } else if(token) {
        navigate(-1);
      } else {
        navigate("/login");
      }
    } catch (error) {
      navigate("/login");
    }
  };

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(true);
    context.handleSetAppContentClass("p-0");

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass("");
    };
  }, [context]);

  return (
    <div
      className="d-flex justify-content-center "
      style={{
        height: "100vh",
        overflow: "hidden",
        backgroundColor: dark === 'false' ? "#F0F4F8" : "#161A1D",
      }}
    >
      <div className="col-md-6 d-flex flex-column justify-content-center align-items-center position-relative">
        <img src={dark === 'false' ? darkLogo : lightLogo} width={250} alt="logo" className="position-absolute" style={{top: '30px', filter: 'hue-rotate(45deg)'}}/>
        <img src={errorgif} alt="error" width="75%" style={{filter: 'hue-rotate(20deg)'}}/>
        <div className="text-center w-100 content-404">
          <h1 className="p-2" style={{ backgroundColor: dark === 'false' ? "#F1F5F9" : "#161A1D" }}>
            Ooops! Página não encontrada
          </h1>
          <Button
            label="Voltar Para o Início"
            className="bg-blue"
            rounded
            onClick={redirectToDashboardOrLogin}
          />
        </div>
      </div>
    </div>
  );
};

export default Error404;
